<template>
  <div class="text-xs h-8 bg-zinc-300 p-2">a9cb5eb3</div>
</template>